import { render } from "./Spatial.vue?vue&type=template&id=2377c394"
import script from "./Spatial.vue?vue&type=script&lang=js"
export * from "./Spatial.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__